import React, { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { normalizeJoinCode } from '../../quizLive/normalizeJoinCode';

export default function JoinLive() {
  const navigate = useNavigate();

  const [pinRaw, setPinRaw] = useState('');
  const [nickname, setNickname] = useState(() => {
    try {
      return String(window.localStorage.getItem('live_quiz_nickname') || '');
    } catch {
      return '';
    }
  });

  const code = useMemo(() => normalizeJoinCode(pinRaw).slice(0, 6), [pinRaw]);
  const canJoin = /^[A-Z0-9]{6}$/.test(code);

  return (
    <div className="min-h-screen bg-background text-foreground flex items-center justify-center p-4">
      <div className="w-full max-w-md rounded-2xl border border-border bg-card overflow-hidden">
        <div className="p-4 border-b border-border">
          <div className="text-xs text-muted-foreground">Quiz Live</div>
          <div className="text-lg font-semibold">Entra con PIN</div>
        </div>

        <div className="p-4 space-y-3">
          <label className="block text-sm">
            <div className="text-xs text-muted-foreground mb-1">Codice (6 caratteri)</div>
            <input
              value={pinRaw}
              onChange={(e) => setPinRaw(e.target.value)}
              inputMode="text"
              className="w-full px-3 py-2 rounded-xl bg-background border border-border text-foreground text-base tracking-widest"
              placeholder="ABC123"
            />
            <div className="mt-1 text-[11px] text-muted-foreground">Codice rilevato: <span className="font-mono">{code || '—'}</span></div>
          </label>

          <label className="block text-sm">
            <div className="text-xs text-muted-foreground mb-1">Nickname (opzionale)</div>
            <input
              value={nickname}
              onChange={(e) => setNickname(e.target.value)}
              className="w-full px-3 py-2 rounded-xl bg-background border border-border text-foreground text-base"
              placeholder="Es: Luca"
            />
            <div className="mt-1 text-[11px] text-muted-foreground">Se lasci vuoto, entrerai come anonimo.</div>
          </label>

          <button
            type="button"
            disabled={!canJoin}
            onClick={() => {
              try {
                window.localStorage.setItem('live_quiz_nickname', nickname.trim());
              } catch {
                // ignore
              }
              const q = nickname.trim() ? `?n=${encodeURIComponent(nickname.trim().slice(0, 20))}` : '';
              navigate(`/join/${code}${q}`);
            }}
            className={
              'w-full px-4 py-2 rounded-xl text-sm ' +
              (canJoin ? 'bg-primary text-primary-foreground' : 'bg-muted text-muted-foreground')
            }
          >
            Entra
          </button>

          <div className="text-[11px] text-muted-foreground">Nessun account richiesto. Apri il link e inserisci il codice.</div>
        </div>
      </div>
    </div>
  );
}
